<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-www`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M45 16C41.8 7.805 33.828 2 24.5 2S7.2 7.805 4 16h4.371C11.316 10.073 17.433 6 24.5 6c7.068 0 13.184 4.073 16.13 10H45zM6.128 18.5l1.382 4.89 1.499-4.89h3.014l1.446 4.862 1.347-4.862h4.578l1.386 4.893 1.5-4.893h3.013l1.446 4.862 1.347-4.862h5.21l1.385 4.893 1.5-4.893h3.014l1.446 4.862 1.346-4.862h3.694l-3.446 11h-3.207l-1.408-4.717-1.519 4.717h-3.137l-2.321-7.357-2.31 7.357h-3.207l-1.407-4.717-1.52 4.717h-3.136l-2.008-6.356-1.992 6.356h-3.207l-1.408-4.717L8.93 29.5H5.792l-3.474-11h3.81zM8.372 32c2.945 5.927 9.06 10 16.128 10 7.067 0 13.183-4.073 16.129-10h4.37C41.8 40.196 33.828 46 24.5 46S7.2 40.195 4 32h4.372z"/></svg>
</template>
<script>

export default {
  name: 'IconWww',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
